import { useEffect, useState } from "react";
import Joi from "joi-browser";

export default useConditionRuleForm;

export const conditionRuleFormSchema = {
  name: Joi.string().required().label("Name"),
  description: Joi.string().allow(null, "").label("Description"),
  rules: Joi.array().min(1).label("Rules"),
};

export const getConditionRuleConfigureData = (conditionRule) => {
  return {
    name: conditionRule.name,
    description: conditionRule.description,
    rules: conditionRule.rules,
  };
};

function useConditionRuleForm(conditionRule, validationErrors = {}) {
  const [formState, setFormState] = useState(() =>
    getConditionRuleConfigureData(conditionRule),
  );

  const [errors, setErrors] = useState(validationErrors);

  useEffect(() => {
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    }
  }, [validationErrors]);

  const updateFormState = (field, value) => {
    setFormState((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  const validate = () => {
    const schema = Joi.object(conditionRuleFormSchema);
    const { error } = schema.validate(formState, { abortEarly: false });

    if (!error) {
      setErrors({});
      return true;
    }

    const fieldErrors = {};
    error.details.forEach((detail) => {
      fieldErrors[detail.path[0]] = detail.message;
    });

    setErrors(fieldErrors);
    return false;
  };

  return { formState, errors, updateFormState, validate };
}
